import { useNavigate } from "react-router-dom";

function Privacy() {
  const navigate = useNavigate();

  const submitHandler = () => {
    navigate("/ready", { replace: true });
  };

 
  return (
    <div className="login-container">
      <div className="login-card">
            <h1 className="step-title">Privacy & Trust</h1>
            <div className="step-icon privacy-icon">
              <svg width="28" height="28" fill="none" stroke="white" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.031 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
              </svg>
            </div>
            <p className="privacy-subtitle">Your Wellness Guide</p>

            <div className="privacy-content">
              <div className="privacy-list">
                <div className="privacy-item">
                  <div className="privacy-label">We Provide:</div>
                  <div className="privacy-text">Stories & context based on your body's signals</div>
                </div>

                <div className="privacy-item">
                  <div className="privacy-label">We Help:</div>
                  <div className="privacy-text">You understand wellness through relatable examples</div>
                </div>

                <div className="privacy-item">
                  <div className="privacy-label">We Suggest:</div>
                  <div className="privacy-text">Small, cultural, actionable steps for your day</div>
                </div>

                <div className="privacy-item">
                  <div className="privacy-label danger">We Don't:</div>
                  <div className="privacy-text">Diagnose, treat, or replace your doctor</div>
                </div>
              </div>

              <hr className="login-divider" />

              <div className="disclaimer-box">
                By continuing, you understand this is for wellness guidance only. Always consult
                healthcare providers for medical advice.
              </div>

              <button onClick={submitHandler} className="wellness-btn">
                Start My Wellness Journey →
              </button>
            </div>

      </div>
    </div>
  );
}

export default Privacy;
